import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MonitoringFilterAdjustUiPipe, ULI_ORIGIN_UI_TITLE_BY_ORIGIN } from '../../common';

@Component({
  selector: 'ui-acronym-icon',
  templateUrl: './acronym-icon.component.html',
  styleUrls: ['./acronym-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcronymIconComponent implements OnInit {
  @Input() set text(text: string) {
    if (text) {
      this.origin = ULI_ORIGIN_UI_TITLE_BY_ORIGIN[text] || text;
    }
  }

  @Input() tooltip?: string;
  @Input() sapClientData?: boolean;
  origin: string = null;
  sapDetails: string;

  constructor(public monitoringFilterAdjustUiPipe: MonitoringFilterAdjustUiPipe) {}

  ngOnInit(): void {
    this.sapDetails = this.monitoringFilterAdjustUiPipe.transform(this.origin);
    this.sapDetails = this.sapDetails + ' ' + this.tooltip;
  }
}
